// extracted by mini-css-extract-plugin
module.exports = {"baseInput":"Input_baseInput__286qT"};